import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Api } from './api';
import { Dashboard } from '../models/dashboard.model';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http'; 

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  private endpoint = '/dashboards';

  constructor(private api: Api) { }

  getDashboards(page: number = 0, size: number = 20, sort: string = 'id,asc'): Observable<Dashboard[]> {
    const params = {
      page: page.toString(),
      size: size.toString(),
      sort: sort
    };
    return this.api.get(this.endpoint, params);
  }

  getDashboard(id: number): Observable<Dashboard> {
    return this.api.get(`${this.endpoint}/${id}`);
  }

  createDashboard(dashboard: Partial<Dashboard>): Observable<Dashboard> {
    return this.api.post(this.endpoint, dashboard);
  }

  updateDashboard(id: number, dashboard: Partial<Dashboard>): Observable<Dashboard> {
    return this.api.putGenerate(`${this.endpoint}/${id}`, dashboard);
  }

  patchDashboard(id: number, dashboard: Partial<Dashboard>): Observable<Dashboard> {
    return this.api.patchGenerate(`${this.endpoint}/${id}`, dashboard);
  }

  deleteDashboard(id: number): Observable<void> {
    return this.api.delete(`${this.endpoint}/${id}`);
  }

  searchDashboards(query: string, page: number = 0, size: number = 20): Observable<Dashboard[]> {
    const params = {
      query,
      page: page.toString(),
      size: size.toString()
    };
    return this.api.get(`${this.endpoint}/search`, params);
  }
      getDashboardsByReportId(reportId:number): Observable<Dashboard[]> {
    return this.api
      .getAll<Dashboard>(this.endpoint + "?reportId.equals=" + reportId, { size: 5000 })
      .pipe(map((res: HttpResponse<Dashboard[]>) => res.body || []));
  }
  getDashboardsGrid(
    page: number = 0,
    size: number = 20,
    sort: string = 'createdDt,desc'
): Observable<Dashboard[]> {
    const params = {
      page: page.toString(),
      size: size.toString(),
      sort: sort
    };
    return this.api.get(this.endpoint, params);
  }
}